import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";

const useModalWrapper = (open, onClose) => {
  const [isOpen, setIsOpen] = useState(open || false);

  const theme = useTheme();

  useEffect(() => {
    setIsOpen(open || false);
  }, [open]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    setIsOpen(false);
    onClose && onClose();
  };

  return { theme, isOpen, handleOpen, handleClose };
};

export default useModalWrapper;
